import { CartActions } from './../constants/actionType'
import * as checkoutAction from './checkout'
import { logOtherInfo,detailsInfo } from './../service/logService'

export const cartToggle = (action, dispatch, visitId,buildProduct) => {
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'cartToggle', "Inside cartToggle : action is : " + action));
    if(action==="existing"){
        dispatch({
            type: CartActions.toggleProfileCart,
            value: ""
        });
    }else{
        dispatch({ type: CartActions.toggleCart, value: "" });
    }
    
    if (action === "checkout" || action==="minicart") {
        checkoutAction.doValidateCart(visitId, dispatch,'BuildProduct', null, action,buildProduct );
    }
};
export const offersToggle = (action, dispatch,visitId) => {
    logOtherInfo(detailsInfo('Cart',visitId,'offersToggle',"Inside offersToggle"));
    dispatch({ type: CartActions.toggleOffers, value: action });
};

export const splitBillTab = (action, dispatch) => {
    dispatch({ type: CartActions.splitBillTab, value: action });
}

export const toggleToolTip = (dispatch) => {
    dispatch({ type: 'TOGGLE_TOOLTIP', value: "" });
};

export const showDueMonthlyDetails =(dispatch, action) => {
    dispatch({type: 'SHOW_DUE_MONTHLY_DETAILS', value:action})
}

export const toggleOneTimeCharges =(dispatch, action) => {
    dispatch({type: 'TOGGLE_ONE_TIME_CHARGES', value:action})
}

export const toggleMonthlyCharges =(dispatch, action) => {
    dispatch({type: 'TOGGLE_MONTHLY_CHARGES', value:action})
}

export const fiosSetupFee = (action, dispatch) => {
    dispatch({ type: 'FIOSSETUPFEE', value: action });
};

export const mobileHelpReveal = (status, dispatch) => {
    dispatch({ type: 'MOBILE_HEADER', value: status })
}; 
